const blogs = [
  {
    id: 1,
    date: "2024-06-27",
    picture: {
      avif: "img/b1.avif",
      webp: "img/b1.webp",
      jpg: "img/b1.jpg",
    },
    title: "Dicas Essenciais para Ganhar no Aviator no LUXO777",
    descr:
      "Descubra estratégias eficazes para aumentar suas chances de sucesso no Aviator.",
    fullText: `O Aviator é um dos jogos mais emocionantes e dinâmicos do LUXO777. Neste artigo, vamos explorar estratégias valiosas que podem ajudar você a ter mais sucesso no jogo.\n\n1. Gerencie suas apostas com sabedoria: Sempre defina um orçamento antes de começar a jogar.\n\n2. Aproveite os bônus exclusivos do LUXO777, como as ofertas festivas de Natal e Ano Novo. Elas podem aumentar significativamente suas chances.\n\n3. Entenda o momento certo de retirar seus ganhos. O segredo do Aviator está em decidir o momento exato de parar.\n\n4. Pratique com apostas menores no início e aumente gradualmente suas apostas conforme pega o jeito do jogo.\n\n5. Monitore os multiplicadores anteriores. Embora seja um jogo de sorte, observar padrões pode ajudar a tomar melhores decisões.\n\n6. Aproveite as funcionalidades do LUXO777, como o suporte em tempo real e promoções diárias.\n\n7. Utilize o app LUXO777 para jogar com mais praticidade em qualquer lugar e a qualquer hora.\n\n8. Por fim, mantenha a calma e aproveite a experiência. O Aviator é um jogo divertido, e o foco no controle traz mais sucesso a longo prazo.`,
  },
  {
    id: 2,
    date: "2024-06-25",
    picture: {
      avif: "img/b2.avif",
      webp: "img/b2.webp",
      jpg: "img/b2.jpg",
    },
    title: "Como Maximizar Seus Ganhos no Fortune Tiger",
    descr: "Saiba como aproveitar ao máximo o slot Fortune Tiger no LUXO777.",
    fullText: `O Fortune Tiger é um dos slots mais populares no LUXO777, e não é por acaso! Com alta taxa de RTP e recursos incríveis, ele oferece ótimas oportunidades.\n\n1. Escolha suas apostas com sabedoria. Sempre comece com apostas menores e aumente gradualmente.\n\n2. Ative as rodadas bônus! O Fortune Tiger conta com símbolos especiais que desbloqueiam multiplicadores incríveis.\n\n3. Aproveite os bônus do LUXO777, como a promoção “Pegue um presente do Papai Noel” durante as festas de fim de ano.\n\n4. Jogue com calma e foco. O Fortune Tiger oferece uma experiência envolvente, então mantenha o controle do seu orçamento.\n\n5. Utilize a versão demo para conhecer melhor os símbolos e recursos do jogo antes de apostar dinheiro real.\n\n6. Explore o app LUXO777 para jogar com mais praticidade e garantir acesso exclusivo a promoções.\n\n7. Mantenha-se atualizado com as promoções sazonais. O LUXO777 sempre oferece novidades festivas que aumentam suas chances.\n\n8. Curta a diversão e aproveite o universo do Fortune Tiger. Com paciência e estratégia, você pode conquistar grandes prêmios!`,
  },
  {
    id: 3,
    date: "2024-06-20",
    picture: {
      avif: "img/b3.avif",
      webp: "img/b3.webp",
      jpg: "img/b3.jpg",
    },
    title: "Guia Completo para Baixar e Usar o App LUXO777",
    descr:
      "Aprenda como instalar o aplicativo LUXO777 e aproveitar todas as suas vantagens.",
    fullText: `O aplicativo LUXO777 oferece a melhor experiência de jogos online na palma da sua mão. Confira o guia completo de instalação e uso.\n\n1. Acesse o site oficial do LUXO777 e vá até a seção “Baixar”.\n\n2. Escolha a versão compatível com seu dispositivo (Android ou iOS) e faça o download.\n\n3. Instale o app e faça login com sua conta LUXO777. Se ainda não tiver uma conta, cadastre-se para ganhar um bônus especial.\n\n4. Através do app, você pode acessar todos os jogos, incluindo Aviator, Fortune Tiger e muito mais.\n\n5. Receba notificações em tempo real sobre promoções exclusivas, como “Ano Novo - Bônus Agradáveis”.\n\n6. Aproveite a segurança avançada oferecida pelo app LUXO777. Seus dados estão protegidos com criptografia.\n\n7. O app é otimizado para garantir jogabilidade rápida e fluida em qualquer lugar.\n\n8. Baixe agora o app LUXO777, resgate suas promoções e descubra uma experiência única de jogos online!`,
  },
  {
    id: 4,
    date: "2024-06-18",
    picture: {
      avif: "img/b4.avif",
      webp: "img/b4.webp",
      jpg: "img/b4.jpg",
    },
    title: "Por Que o LUXO777 é a Melhor Plataforma de Jogos?",
    descr: "Conheça os principais diferenciais que tornam o LUXO777 único.",
    fullText: `O LUXO777 se destaca como uma plataforma de jogos premium, oferecendo segurança, qualidade e bônus exclusivos.\n\n1. Grande variedade de jogos: No LUXO777, você encontra slots, jogos de mesa e títulos como Aviator e Fortune Tiger.\n\n2. Bônus especiais: Ofertas sazonais, como “Pegue um presente do Papai Noel”, garantem uma experiência única.\n\n3. Plataforma segura: O LUXO777 utiliza criptografia avançada para proteger seus dados.\n\n4. Disponibilidade 24/7: Jogue a qualquer hora e em qualquer lugar com o app LUXO777.\n\n5. Suporte dedicado: Conte com atendimento ao cliente sempre que precisar.\n\n6. RTP alto: Jogos como Fortune Tiger garantem excelentes taxas de retorno ao jogador.\n\n7. Atualizações frequentes: O LUXO777 oferece promoções contínuas e novos jogos regularmente.\n\n8. Experimente o LUXO777 agora e aproveite uma plataforma projetada para a sua diversão e grandes vitórias!`,
  },
  {
    id: 5,
    date: "2024-06-15",
    picture: {
      avif: "img/b5.avif",
      webp: "img/b5.webp",
      jpg: "img/b5.jpg",
    },
    title: "Estratégias Eficientes para Jogar Slots no LUXO777",
    descr: "Dicas e truques para ter sucesso nos melhores slots do LUXO777.",
    fullText: `Os slots são uma das categorias mais amadas no LUXO777. Confira dicas valiosas para aumentar suas chances.\n\n1. Escolha slots com alta taxa de RTP. Jogos como Fortune Tiger oferecem excelentes retornos.\n\n2. Aproveite as rodadas grátis e bônus exclusivos do LUXO777.\n\n3. Defina um orçamento antes de começar a jogar para manter o controle financeiro.\n\n4. Conheça o jogo: Utilize a versão demo para entender os recursos antes de apostar dinheiro real.\n\n5. Jogue slots durante promoções especiais, como o Natal, para ganhar recompensas extras.\n\n6. Monitore seus ganhos e perdas para ajustar sua estratégia.\n\n7. Aposte gradualmente. Comece com valores menores e aumente conforme sua confiança cresce.\n\n8. Por fim, aproveite o LUXO777 e divirta-se. Os slots são uma ótima forma de entretenimento com prêmios incríveis!`,
  },
];

const phone = () => {
  const html = document.querySelector("html");
  const header = document.querySelector(".header");
  const mobile = header.querySelector(".phone");
  const navEl = header.querySelector(".header__nav");
  let timeOut;

  const closephone = (time = 400) => {
    mobile.classList.remove("phone_active");

    navEl.classList.add("header__nav_show");
    navEl.classList.remove("header__nav_active");
    header.classList.remove("header_active");

    html.style.removeProperty("overflow");

    timeOut = setTimeout(() => {
      navEl.classList.remove("header__nav_show");
      navEl.style.removeProperty("top");
      navEl.style.removeProperty("height");
    }, time);
  };

  if (window.innerWidth > 1440) {
    closephone(0);
  }

  mobile.onclick = () => {
    clearTimeout(timeOut);

    if (mobile.classList.contains("phone_active")) {
      closephone();
      return;
    }

    html.style.overflow = "hidden";
    window.scrollTo(0, 0);

    mobile.classList.add("phone_active");
    header.classList.add("header_active");

    navEl.style.top = `${header.clientHeight}px`;
    navEl.style.height = `calc(var(--vh) - ${header.clientHeight}px)`;
    navEl.classList.add("header__nav_show");

    setTimeout(() => {
      navEl.classList.add("header__nav_active");
      navEl.classList.remove("header__nav_show");
    }, 0);
  };
};

const getVisible = (el) => {
  const rect = el.getBoundingClientRect();
  const windowHeight =
    window.innerHeight || document.documentElement.clientHeight;

  const vertInView =
    rect.top <= windowHeight - 50 && rect.top + rect.height >= 0;

  return vertInView;
};

const handleAnim = (collection, t = 0.4, d = 4) => {
  let order = 0;
  collection.forEach((item) => {
    if (item.classList.contains("anim_show")) return;

    if (!getVisible(item)) return;

    item.classList.add("anim_show");
    item.style.setProperty("--t", `${t}s`);
    item.style.setProperty("--d", `${(order * t) / d}s`);
    order++;
  });
};

const animColl = document.querySelectorAll(".anim");
const animFunc = () => {
  if (!animColl) return;
  handleAnim(animColl);
};
animFunc();

const handleSpecPromo = (block) => {
  const wrapper = document.querySelector(".footer__special");

  const changeHeight = () => {
    const height = block.clientHeight;

    if (height === wrapper.clientHeight) return;

    wrapper.style.height = `${height}px`;
  };

  changeHeight();

  window.addEventListener("resize", () => {
    changeHeight();
  });

  const onVisible = () => {
    const isVisible = getVisible(wrapper);

    if (!isVisible) {
      block.classList.add("specialPromo_sticky");
      return;
    }

    if (!block.classList.contains("specialPromo_sticky")) return;

    block.style.width = `${wrapper.clientWidth}px`;
    setTimeout(() => {
      block.classList.remove("specialPromo_sticky");
      block.removeAttribute("style");
    }, 0);
  };

  window.addEventListener("scroll", () => {
    onVisible();
  });

  onVisible();
};

const handleActivePage = () => {
  const url = window.location.pathname;

  const menuLinks = document.querySelectorAll(".menu__link");
  const currLink = [...menuLinks].find((link) => link.href.includes(url));

  if (!currLink) return;

  const menuItem = currLink.closest(".menu__item");
  menuItem.classList.add("menu__item_active");

  currLink.onclick = (e) => {
    e.preventDefault();
  };
};

const onAnimPromo = (block) => {
  const icons = block.querySelectorAll(".specialPromo__icon");

  icons.forEach((icon, i) => {
    const maxScale = 120;
    const minScale = 90;
    let step = 0.7;
    let progress = 100;
    function animIncr() {
      progress += step;
      icon.style.scale = progress / 100;

      if (progress >= maxScale) return requestAnimationFrame(animDecr);

      requestAnimationFrame(animIncr);
    }

    function animDecr() {
      progress -= step;
      icon.style.scale = progress / 100;

      if (progress <= minScale) return requestAnimationFrame(animIncr);

      requestAnimationFrame(animDecr);
    }

    setTimeout(() => {
      requestAnimationFrame(animIncr);
    }, i * 500);
  });
};

class Blog {
  constructor() {
    this.blogs = JSON.parse(localStorage.getItem("blogs"));

    if (!this.blogs) {
      this.setBlogs();
    }
  }

  setBlogs() {
    const newBlogs = blogs.map((blog, i) => {
      const date = new Date();
      date.setDate(date.getDate() - Math.floor(Math.random() * 14));
      date.setMonth(date.getMonth() - i);

      const dd = date.getDate();
      const mm = date.getMonth() + 1;
      const yy = date.getFullYear();
      blog.date = `${yy}-${mm}-${dd}`;

      return blog;
    });

    localStorage.setItem("blogs", JSON.stringify(newBlogs));
    this.blogs = newBlogs;
  }

  getBlogs() {
    return this.blogs;
  }

  setList(wrapper) {
    const template = wrapper.querySelector("#blog");
    this.blogs.forEach((data) => {
      this.setListItem(wrapper, template, data);
    });
  }

  setListItem(wrapper, template, data) {
    const card = template.content.cloneNode(true);

    const img = card.querySelector(".blog__img");
    img.src = data.picture.jpg;

    const picture = card.querySelector(".blog picture");

    if (data.picture.avif) {
      const source = document.createElement("source");
      source.srcset = data.picture.avif;
      (source.type = "image/avif"), picture.insertBefore(source, img);
    }

    if (data.picture.webp) {
      const source = document.createElement("source");
      source.srcset = data.picture.webp;
      (source.type = "image/webp"), picture.insertBefore(source, img);
    }

    const dateEl = card.querySelector(".blog__date");
    dateEl.dateTime = data.date;
    dateEl.textContent = this.getDate(data.date);

    const title = card.querySelector(".blog__title");
    title.textContent = data.title;

    const descr = card.querySelector(".blog__descr");
    descr.textContent = data.descr;

    const url = card.querySelector(".blog__url");
    url.href = `blog-detail.html?id=${data.id}`;

    wrapper.appendChild(card);
  }

  getDate(dateString) {
    const date = new Date(dateString);

    const dd = date.getDate().toString().padStart(2, "0");
    const mm = (date.getMonth() + 1).toString().padStart(2, "0");
    const yy = date.getFullYear();

    return `${dd}.${mm}.${yy}`;
  }

  setDetail(wrapper) {
    const params = new URLSearchParams(window.location.search);
    const id = parseInt(params.get("id"));

    if (!id) {
      window.location.assign("blog.html");
    }

    const blog = this.blogs.find((item) => item.id === id);

    if (!blog) {
      window.location.assign("blog.html");
    }

    const headTitle = document.querySelector("title");
    if (headTitle) headTitle.textContent = blog.title;

    const metaDescr = document.querySelector('meta[name="description"]');
    if (metaDescr) metaDescr.content = blog.descr;

    const template = wrapper.querySelector("#blog");
    const block = template.content.cloneNode(true);

    const img = block.querySelector(".blogDetail__img");
    img.src = blog.picture.jpg;

    const picture = block.querySelector("picture");

    if (blog.picture.avif) {
      const source = document.createElement("source");
      source.srcset = blog.picture.avif;
      (source.type = "image/avif"), picture.insertBefore(source, img);
    }

    if (blog.picture.webp) {
      const source = document.createElement("source");
      source.srcset = blog.picture.webp;
      (source.type = "image/webp"), picture.insertBefore(source, img);
    }

    const dateEl = block.querySelector(".blogDetail__date");
    dateEl.dateTime = blog.date;
    dateEl.textContent = this.getDate(blog.date);

    const title = block.querySelector(".blogDetail__title");
    title.textContent = blog.title;

    const descr = block.querySelector(".blogDetail__descr");
    descr.textContent = blog.descr;

    const content = block.querySelector(".blogDetail__content");
    content.innerHTML = blog.fullText.replaceAll("\n", "<br>");

    wrapper.appendChild(block);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const accordionColl = document.querySelectorAll(".accord");
  accordionColl.forEach((item) => {
    const accordion = item;

    const closeAccord = (accord, wrapper, answer) => {
      wrapper.style.height = `${answer.clientHeight}px`;

      setTimeout(() => {
        wrapper.style.height = "0px";
        accord.classList.remove("accord_active");
      }, 0);

      setTimeout(() => {
        wrapper.removeAttribute("style");
        accord.classList.remove("accord_active");
      }, 400);
    };

    accordion.onclick = () => {
      const wrapper = accordion.querySelector(".accord__wrapper");
      const answer = accordion.querySelector(".accord__content");

      if (accordion.classList.contains("accord_active")) {
        closeAccord(accordion, wrapper, answer);
        return;
      }

      const currActive = document.querySelector(".accord_active");
      if (currActive) {
        const activeWrapper = currActive.querySelector(".accord__wrapper");
        const activeAnswer = currActive.querySelector(".accord__content");
        closeAccord(currActive, activeWrapper, activeAnswer);
      }

      wrapper.style.height = `${answer.clientHeight}px`;

      accordion.classList.add("accord_active");
      setTimeout(() => {
        wrapper.removeAttribute("style");
      }, 400);
    };
  });

  const blogsSec = document.querySelector(".blogs");
  if (blogsSec) {
    const blog = new Blog();
    const wrapper = blogsSec.querySelector(".blogs__list");
    blog.setList(wrapper);
  }

  const blogSec = document.querySelector(".blogDetail");
  if (blogSec) {
    const blog = new Blog();
    const wrapper = blogSec.querySelector(".blogDetail__wrapper");
    blog.setDetail(wrapper);
  }

  const specPromo = document.querySelector(".specialPromo");
  if (specPromo) {
    handleSpecPromo(specPromo);
  }

  const years = document.querySelectorAll(".year");
  if (years) {
    const date = new Date();
    const yy = date.getFullYear();

    years.forEach((year) => {
      year.textContent = yy;
    });
  }

  const promo = document.querySelector(".specialPromo");
  if (promo) {
    onAnimPromo(promo);
  }

  handleActivePage();

  phone();

  window.onresize = () => {
    phone();
    animFunc();
  };

  window.onscroll = () => {
    animFunc();
  };

  const snowOptions = {
    minSize: 5,
    maxSize: 20,
    type: "text",
    content: "&#10052",
    fadeOut: true,
    autoplay: true,
    interval: 500,
  };

  const snow = new Snowfall(snowOptions);
});
